import { OnboardingPage } from '@/ui'
import { roleEnum } from '@jobilla/nexus-sdk'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/onboarding')({
	beforeLoad: ({ context }) => {
		const { auth } = context
		if (
			auth.user?.onboardingCompletedAt
			|| auth.role === roleEnum.jobillan
			|| auth.user?.email.toLowerCase().endsWith('@jobilla.com')
		) {
			throw redirect({ to: '/company' })
		}
	},
	component: OnboardingPage,
})
